import { useState } from 'react';
import '../index.css';

const API_URL = process.env.REACT_APP_API_URL || "/api";

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();  // Prevent the default form submission behavior

    const response = await fetch(API_URL + '/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      withCredentials: true,
      body: JSON.stringify({ username, password })
    });

    console.log(response)

    if (response.ok) {
      // You can redirect to the homepage or protected page if login is successful
      window.location.href = '/';
    } else {
      // If there's an error (e.g., invalid credentials), show an error message
      const data = await response.json();
      setError(data.msg || 'Login failed');
    }

  };

  return (
    <div className="login-container">
      <h2>Login</h2>
      <form onSubmit={handleLogin}>
        <div>
          <label htmlFor="username">Username:</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error && <p className="error">{error}</p>}
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default Login;
